export var PREV = 'prev';
export var NEXT = 'next';